import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

export function useIsInRoutePage() {
  const pathname = usePathname()
  const isInRoutePage = useMemo(() => pathname.startsWith('/route'), [pathname])

  return isInRoutePage
}
